/**
 * Implements file exporter
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import environment from "../common/environment";
import { createIFrame } from "./";

const FILE_EXPORT_EVENT = "file-export";
const FILE_LINK_EVENT = "file-link";
const IE_MAX_URL_LENGTH = 2000;
const IE_MAX_URL_LENGTH_MESSAGE =
  "Your report exceeds Internet Explorer's export limitations. Please use a more modern browser, like Chrome or Firefox.";

class FileExporter extends Marionette.Object {
  initialize() {
    // add iframe
    this.el = createIFrame();
    this.$el = $(this.el);

    // setup listeners
    this.globalChannel = Radio.channel("global");
    this.reportChannel = Radio.channel("report");

    this.listenTo(this.globalChannel, FILE_EXPORT_EVENT, this.handleFileExport);
    this.listenTo(this.globalChannel, FILE_LINK_EVENT, this.handleFileLink);
  }

  handleFileExport(route) {
    // find the route's model in history store
    const model = this.reportChannel.request("history:find", route);

    // if found, build export url and call it
    if (model) {
      const exportUrl = model.getExportUrl();
      if (
        RVC.internetExplorerVersion &&
        exportUrl &&
        exportUrl.length > IE_MAX_URL_LENGTH
      ) {
        // display warning
        this.globalChannel.trigger("status:show", {
          type: "warning",
          autoDismissTimeout: 5000,
          message: IE_MAX_URL_LENGTH_MESSAGE,
        });
      } else {
        // load export URL
        this.$el.get(0).src = exportUrl;
      }
    }
  }

  handleFileLink(path, windowName = "rvcLink") {
    const url = `${environment.getAppHost()}${path}`;
    // load file in new window
    window.open(url, windowName);
  }
}

export { FileExporter as default };
